
import { useT } from '../i18n/index.js';/**
 * The only screens that render without a tenant context: an unreachable host, a
 * suspended tenant, an onboarding tenant without a preview token, and offline
 * boot (docs/04 §5). They stay branded where we know the brand.
 */

function Shell({
  accent,
  title,
  children,
}: {
  accent: string;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <main className="grid min-h-full place-items-center px-6 py-16">
      <div className="w-full max-w-sm text-center">
        <span
          className="mx-auto mb-6 block h-1 w-12 rounded-full"
          style={{ background: accent }}
          aria-hidden
        />
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        <div className="mt-2 text-sm" style={{ color: 'rgba(17,17,17,.62)' }}>
          {children}
        </div>
      </div>
    </main>
  );
}

export function SuspendedScreen({ appName, primary }: { appName: string; primary: string }) {
  const t = useT();
  return (
    <Shell accent={primary} title={`${appName} is temporarily unavailable`}>
      <p>{t('mt.paused')}</p>
      <p className="mt-2">{t('mt.checkBack')}</p>
    </Shell>
  );
}

export function NotLiveScreen({ appName, primary }: { appName: string; primary: string }) {
  const t = useT();
  return (
    <Shell accent={primary} title={`${appName} is not open yet`}>
      <p>{t('mt.beingSetUp')}</p>
      <p className="mt-2">If you are reviewing it, open the preview link from your dashboard.</p>
    </Shell>
  );
}

export function UnknownHostScreen() {
  const t = useT();
  return (
    <Shell accent="#B91C1C" title={t('mt.noSite')}>
      <p>{t('mt.checkAddress')}</p>
    </Shell>
  );
}

export function OfflineBootScreen() {
  const t = useT();
  return (
    <Shell accent="#B45309" title={t('mt.offline')}>
      <p>{t('mt.offlineHint')}</p>
    </Shell>
  );
}
